import { useQuery } from '@tanstack/react-query'
import { weeklyProgramsAPI } from '../../services/api'
import { ScoreChip } from './ScoreChip'

export function SessionScoreDisplay({ sessionId, isSubmitted }) {
  const { data: scoreData } = useQuery({
    queryKey: ['sessionScore', sessionId],
    queryFn: () => weeklyProgramsAPI.getSessionScore(sessionId),
    enabled: isSubmitted,
    staleTime: 5 * 60 * 1000,
    retry: false
  })

  const score = scoreData?.data
  if (!score) return null

  return (
    <ScoreChip
      score={score.total_score}
      showTrophy={score.is_personal_best}
      size="sm"
    />
  )
}
